"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCellPropertiesDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../../../base-utils/map-creator");
var table_cell_properties_destination_core_1 = require("./table-cell-properties-destination-core");
var table_cell_style_destination_1 = require("./table-cell-style-destination");
var TableCellPropertiesDestination = (function (_super) {
    tslib_1.__extends(TableCellPropertiesDestination, _super);
    function TableCellPropertiesDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TableCellPropertiesDestination.prototype, "elementHandlerTable", {
        get: function () {
            return TableCellPropertiesDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    TableCellPropertiesDestination.handlerTable = new map_creator_1.MapCreator(table_cell_properties_destination_core_1.TableCellPropertiesDestinationCore.handlerTable)
        .add('tblCStyle', function (data) { return new table_cell_style_destination_1.TableCellStyleDestination(data, data.destinationStack.getThis().cell); })
        .get();
    return TableCellPropertiesDestination;
}(table_cell_properties_destination_core_1.TableCellPropertiesDestinationCore));
exports.TableCellPropertiesDestination = TableCellPropertiesDestination;
